import {
  Box,
  Divider,
  FormControlLabel,
  InputAdornment,
  styled,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 759,
  maxHeight: "95vh",
  overflow: "auto",
  background: theme.palette.custom.virtualSuccess,
  borderRadius: theme.borderRadius.radius.large,
  color: theme.palette.custom.white,

  outline: "none",

  [theme.breakpoints.down("md")]: {
    width: 530,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  [theme.breakpoints.down("xs")]: {
    width: 270,
  },
}));

export const StyledMain = styled(Box)(() => ({
  padding: '0px 24px 24px 24px',
  overflow: 'auto'
}));
export const ModalHeader = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
export const StyledBoxGap = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "10px 10px",
  marginBottom: "38px",
}));
export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  color: theme.palette.custom.productTextColor,
  marginTop: "18px",
}));
export const StyledTypographyDetails = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.virtualTitle,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingLeft: "50px",
  [theme.breakpoints.down("md")]: {
    paddingLeft: "0px",
  },
}));
export const StyledTypographyInformation = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.uploadColor,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingRight: "15px",

  [theme.breakpoints.down("sm")]: {
    paddingRight: "0px",
    textAlign: "end",
  },
}));
export const StyledTypographyOrder = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.OrderTextColor,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  padding: "18px 0px",
}));
export const StyledBoxBorder = styled(Box)(({ theme, colorBg }) => ({
  background: colorBg
    ? theme.palette.custom.startInputBgColor
    : theme.palette.custom.uploadColor,
  width: "200px",
  height: "2px",
  [theme.breakpoints.down("md")]: {
    width: "160px",
  },
}));
export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.xLarge.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  paddingTop: "24px",

  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.large.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
  paddingTop: "12px",
}));
export const ButtonWrapper = styled(Box)(() => ({
  paddingTop: "24px",
  width: "141px",
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  cursor: "pointer",
})); export const StyledAssistantTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.productTextColor,
  fontSize: theme.typography.small.fontSize

}));
export const StyledTypographyEnter = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.profileSuccessDes,
}));
export const StyledBoxWrapper = styled(Box)(() => ({
  marginTop: "42px",
  display: "flex",
  justifyContent: "flex-end",
}));
export const StyledBoxWrapperButton = styled(Box)(() => ({
  display: "flex",
  marginTop: "37px",
  justifyContent: "flex-end",
  bottom: 0,
  position: 'sticky',
}));
export const StyledBoxStart = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  height: 44,
  borderTopLeftRadius: theme.borderRadius.radius.wallet,
  borderBottomLeftRadius: theme.borderRadius.radius.wallet,
  background: theme.palette.custom.searchBg,
  border: theme.borders.boxBorder,
  marginRight: "8px",
}));
export const StyledTypographyRup = styled(Box)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  color: theme.palette.custom.startInputColor,
  padding: "10px 16px",
  textAlign: "center",
}));
export const StyledInputAdornment = styled(InputAdornment)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  background: theme.palette.custom.searchBg,
  margin: "0px",
}));
export const StyledGrid = styled(Grid)(({ theme, isactive }) => ({
  color:
    isactive === true
      ? theme.palette.custom.white
      : theme.palette.custom.orderCards,
  border: "1px solid #D6D8D9",
  display: "flex",
  justifyContent: "center",
  height: "100px",
  alignItems: "center",
  borderRadius: theme.borderRadius.radius.wallet,
  backgroundColor:
    isactive === true
      ? theme.palette.custom.primary
      : theme.palette.custom.white,
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
}));
export const StyledBoxUpload = styled(Box)(({ theme }) => ({
  height: "198px",
  display: "flex",
  gap: "18px",
  cursor: "pointer",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  backgroundColor: theme.palette.custom.white,
  border: "1px solid #D6D8D9",
  borderRadius: theme.borderRadius.radius.wallet,
}));
export const StyledTypographyProduct = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  color: theme.palette.custom.uploadProductColor,
}));
export const StyledDivider = styled(Divider)(() => ({
  marginTop: "30px",
}));
export const StyledBoxButton = styled(Box)(() => ({
  marginTop: "24px",
}));
export const StyledInputGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  marginTop: "20px",
  [theme.breakpoints.down("md")]: {
    marginTop: "0px",
  },
}));
export const StyledBoxCard = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  display: "flex",
  justifyContent: 'space-between',
  padding: "13px 25px",
  alignItems: "center",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
  position: "sticky",
  top: 0, 
  zIndex: 10,
}));